import apiClient from "../config/apiClient";


export const fetchGroupedTest = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=lab-tests/groups`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
